import React from 'react'
import { Link, Imgix } from '@elements'

export const ImageList = ({ imageList, imageListHeadline, ImageListText }) => {
  return (
    <div className="mt-16 xl:mt-24">
      <h2 className="font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
        {imageListHeadline}
      </h2>
      <div dangerouslySetInnerHTML={{ __html: ImageListText }}></div>
      <div className="flex flex-wrap pt-10 mt-6 border-t-2 border-gray-400 sm:justify-center">
        {imageList.map((image, idx) => (
          <Link
            to={image.imageLink}
            key={idx}
            className="flex items-center justify-center w-full mt-6 sm:w-1/2 lg:w-1/3"
          >
            <Imgix
              src={image.image.mediaItemUrl}
              alt={image.image.altText}
              className="w-full sm:w-48"
            />
          </Link>
        ))}
      </div>
    </div>
  )
}
